/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonCovenantCommitteeRequest = {
    sortField?: BabylonCovenantCommitteeRequest.sortField;
    sortDirection?: BabylonCovenantCommitteeRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonCovenantCommitteeRequest {

    export enum sortField {
        SIGNED_DELEGATION_COUNT = 'SIGNED_DELEGATION_COUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

